import { useEffect, useRef } from 'react';

/**
 * Código de verificación: un solo campo donde se teclea o se pega el código completo. El largo lo
 * decide Supabase (`mailer_otp_length`) y llega por prop para el `maxLength` y el placeholder. El
 * filtrado vive en una función pura probada: este campo es el único camino para entrar.
 */

/** Deja solo los dígitos del texto y lo recorta al largo. Pegar «1234 5678» da «12345678». */
export function soloDigitos(texto: string, largo: number): string {
  return (texto ?? '').replace(/\D/g, '').slice(0, largo);
}

export function CampoCodigo({
  largo,
  valor,
  onCambio,
  etiqueta,
  e2e,
}: {
  largo: number;
  valor: string;
  onCambio: (codigo: string) => void;
  etiqueta: string;
  e2e?: string;
}) {
  const campo = useRef<HTMLInputElement | null>(null);

  // Al aparecer, el foco va al campo: el paso siguiente es escribir el código.
  useEffect(() => {
    campo.current?.focus();
  }, []);

  return (
    <input
      ref={campo}
      value={valor}
      onChange={(e) => onCambio(soloDigitos(e.target.value, largo))}
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={largo}
      placeholder={'0'.repeat(largo)}
      aria-label={etiqueta}
      data-e2e={e2e}
      className="num rounded-control border-border bg-card focus:border-primary-deep focus:ring-primary/30 placeholder:text-muted mx-auto block h-14 w-full max-w-xs border text-center text-cifra font-bold tracking-widest outline-none focus:ring-2"
    />
  );
}
